import type { BoardModelKind } from "./kind";
import { appendLocationCohortLabel } from "./ActiveLocationGroup/cohortLabel";

function ensureKindSpan(label: HTMLElement, kind: BoardModelKind): HTMLElement {
  let kindEl = label.querySelector<HTMLElement>(".board-model-debug__label-kind");
  if (kindEl === null) {
    label.replaceChildren();
    kindEl = document.createElement("span");
    kindEl.className = "board-model-debug__label-kind";
    label.append(kindEl);
  }
  kindEl.textContent = kind;
  return kindEl;
}

export function mountBoardModelDebugFrameLabel(
  label: HTMLElement,
  kind: BoardModelKind,
): void {
  if (kind === "Location") {
    if (label.querySelector(".board-model-debug__label-kind") === null) {
      appendLocationCohortLabel(label, kind);
    }
    return;
  }
  ensureKindSpan(label, kind);
}
